import { render, staticRenderFns } from "./CreatePresell.vue?vue&type=template&id=8593ead8&"
import script from "./CreatePresell.vue?vue&type=script&lang=js&"
export * from "./CreatePresell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports